import SEO from "../components/SEO";
import { PAGES } from "../seo/pages.config";
import Breadcrumb from "../components/Breadcrumb";
import DevScaleArea from "../components/DevScaleArea";
import FooterFour from "../components/FooterFour";
import NavBarThree from "../components/NavbarThree";

const DevScale = () => {
  return (
    <>
      <SEO canonical="/accelerator/dev-scale" {...PAGES["/accelerator/dev-scale"]} />
      {/* Navigation Bar */}
      <NavBarThree />

      {/* Navigation Bar */}
      <Breadcrumb title={"Evolvelab Dev Scale"} />

      {/* Service Details Area */}
      <DevScaleArea />

      {/* Footer One */}
      <FooterFour />
    </>
  );
};

export default DevScale;
